exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".PopoverMenu-ce868b0a{list-style-type:none;margin:5px 0;padding:0 0}.PopoverMenuItem-637aeb5c{display:block;font-size:12px;font-weight:500;color:#616161;padding:6px 15px}.PopoverMenuItem-637aeb5c label{font-size:12px;margin:0 0}.listHeading-752de6c2{padding:10px 15px 5px 15px;font-weight:500;user-select:none;font-size:12px;color:#212121;border-bottom:1px solid #E0E0E0}.listHeading-752de6c2:first-child{padding:5px 15px}\n", ""]);

// Exports
exports.locals = {
	"PopoverMenu": "PopoverMenu-ce868b0a",
	"PopoverMenuItem": "PopoverMenuItem-637aeb5c",
	"listHeading": "listHeading-752de6c2"
};